import * as actions from "../actions/AbstractGradingActions";
import { AbstractGradingState, initialState } from "../store/AbstractGradingState";
import buildReducer from "../utils/ReducerBuilder";

export const AbstractGradingReducer = buildReducer<AbstractGradingState>(initialState)
    .handle(actions.onAbstractsUpdated, (state, action) => ({
        ...state,
        abstracts: action.payload || state.abstracts,
    }))
    .handle(actions.onListAbstractsUpdated, (state, action) => ({
        ...state,
        listAbstracts: action.payload || state.listAbstracts,
    }))
    .handle(actions.onReviewerStatsUpdated, (state, action) => ({
        ...state,
        reviewerStats: action.payload || state.reviewerStats,
    }))
    .handle(actions.onTypesUpdated, (state, action) => ({
        ...state,
        types: action.payload || state.types,
    }))
    .handle(actions.toggleLoadingAbstract, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingAbstract = { ...state.loadingAbstract };
        loadingAbstract[action.payload.guid] = action.payload.loading;

        return {
            ...state,
            loadingAbstract,
        };
    })
    .handle(actions.toggleLoadingListAbstracts, (state, action) => ({
        ...state,
        loadingListAbstracts: action.payload || false,
    }))
    .handle(actions.toggleLoadingType, (state, action) => {
        if (action.payload === undefined)
            return state;

        const loadingType = { ...state.loadingType };
        loadingType[action.payload.typeId] = action.payload.loading;

        return {
            ...state,
            loadingType,
        };
    })
    .done();



// WEBPACK FOOTER //
// ./src/reducers/AbstractGradingReducer.ts